module.exports = __webpack_public_path__ + "img/pros.5fa1574c.png";